import MaterialSnackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import DoneIcon from '@material-ui/icons/Done';
import WarningIcon from '@material-ui/icons/Warning';
import * as React from 'react';

interface Props {
  ShowSnackbar: boolean;
  handleCloseSnackbar: () => any;
  SnackbarSuccess: boolean;
  SnackbarMessage: string;
}

interface State {}

class Snackbar extends React.Component<Props, State> {
  public render() {
    const {
      ShowSnackbar,
      SnackbarSuccess,
      handleCloseSnackbar,
      SnackbarMessage
    } = this.props;

    return (
      <MaterialSnackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={ShowSnackbar}
        onClose={handleCloseSnackbar}
        autoHideDuration={2000}
      >
        <SnackbarContent
          className={`snackbar-content snackbar-content--${
            SnackbarSuccess ? 'success' : 'error'
          }`}
          aria-describedby="client-snackbar"
          message={
            <span id="client-snackbar" className="snackbar-span">
              {SnackbarSuccess ? (
                <DoneIcon className="snackbar-icon" />
              ) : (
                <WarningIcon className="snackbar-icon" />
              )}
              {SnackbarMessage}
            </span>
          }
        />
      </MaterialSnackbar>
    );
  }
}

export default Snackbar;
